import { render } from "./SitemapDetail.vue?vue&type=template&id=b892d6f0&scoped=true"
import script from "./SitemapDetail.vue?vue&type=script&lang=js"
export * from "./SitemapDetail.vue?vue&type=script&lang=js"

import "./SitemapDetail.vue?vue&type=style&index=0&id=b892d6f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b892d6f0"]])

export default __exports__